// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as CollectionsRouteImport } from './routes/collections'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DeckRouteImport } from './routes/deck'
import { Route as DescentRouteImport } from './routes/descent'
import { Route as DiscoveriesRouteImport } from './routes/discoveries'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as PlayRouteImport } from './routes/play'
import { Route as PressRouteImport } from './routes/press'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProveMeWrongRouteImport } from './routes/prove-me-wrong'
import { Route as QuizzesRouteImport } from './routes/quizzes'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as ReleaseNotesRouteImport } from './routes/release-notes'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as SurvivalRouteImport } from './routes/survival'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrendingRouteImport } from './routes/trending'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedFounderRouteImport } from './routes/_authenticated/founder'
import { Route as AuthenticatedHealthRouteImport } from './routes/_authenticated/health'
import { Route as AuthenticatedHistoryRouteImport } from './routes/_authenticated/history'
import { Route as AuthenticatedMeRouteImport } from './routes/_authenticated/me'
import { Route as AuthenticatedSavedRouteImport } from './routes/_authenticated/saved'
import { Route as CategorySlugRouteImport } from './routes/category.$slug'
import { Route as ChallengeCodeRouteImport } from './routes/challenge.$code'
import { Route as CollectionsIndexRouteImport } from './routes/collections.index'
import { Route as CollectionsSlugRouteImport } from './routes/collections.$slug'
import { Route as DiscoverySlugRouteImport } from './routes/discovery.$slug'
import { Route as JourneysKeyRouteImport } from './routes/journeys.$key'
import { Route as ProveMeWrongReturnRouteImport } from './routes/prove-me-wrong.return'
import { Route as QuizSlugRouteImport } from './routes/quiz.$slug'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as ShopUltimateTriviaPackRouteImport } from './routes/shop.ultimate-trivia-pack'
import { Route as UUsernameRouteImport } from './routes/u.$username'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CategoriesRoute = CategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => rootRouteImport
          })
const CollectionsRoute = CollectionsRouteImport.update({
            id: '/collections',path: '/collections',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DeckRoute = DeckRouteImport.update({
            id: '/deck',path: '/deck',getParentRoute: () => rootRouteImport
          })
const DescentRoute = DescentRouteImport.update({
            id: '/descent',path: '/descent',getParentRoute: () => rootRouteImport
          })
const DiscoveriesRoute = DiscoveriesRouteImport.update({
            id: '/discoveries',path: '/discoveries',getParentRoute: () => rootRouteImport
          })
const ExploreRoute = ExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => rootRouteImport
          })
const FeedRoute = FeedRouteImport.update({
            id: '/feed',path: '/feed',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const PlayRoute = PlayRouteImport.update({
            id: '/play',path: '/play',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProveMeWrongRoute = ProveMeWrongRouteImport.update({
            id: '/prove-me-wrong',path: '/prove-me-wrong',getParentRoute: () => rootRouteImport
          })
const QuizzesRoute = QuizzesRouteImport.update({
            id: '/quizzes',path: '/quizzes',getParentRoute: () => rootRouteImport
          })
const RefundsRoute = RefundsRouteImport.update({
            id: '/refunds',path: '/refunds',getParentRoute: () => rootRouteImport
          })
const ReleaseNotesRoute = ReleaseNotesRouteImport.update({
            id: '/release-notes',path: '/release-notes',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const SurvivalRoute = SurvivalRouteImport.update({
            id: '/survival',path: '/survival',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrendingRoute = TrendingRouteImport.update({
            id: '/trending',path: '/trending',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedFounderRoute = AuthenticatedFounderRouteImport.update({
            id: '/founder',path: '/founder',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHealthRoute = AuthenticatedHealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHistoryRoute = AuthenticatedHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMeRoute = AuthenticatedMeRouteImport.update({
            id: '/me',path: '/me',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSavedRoute = AuthenticatedSavedRouteImport.update({
            id: '/saved',path: '/saved',getParentRoute: () => AuthenticatedRouteRoute
          })
const CategorySlugRoute = CategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => rootRouteImport
          })
const ChallengeCodeRoute = ChallengeCodeRouteImport.update({
            id: '/challenge/$code',path: '/challenge/$code',getParentRoute: () => rootRouteImport
          })
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CollectionsRoute
          })
const CollectionsSlugRoute = CollectionsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CollectionsRoute
          })
const DiscoverySlugRoute = DiscoverySlugRouteImport.update({
            id: '/discovery/$slug',path: '/discovery/$slug',getParentRoute: () => rootRouteImport
          })
const JourneysKeyRoute = JourneysKeyRouteImport.update({
            id: '/journeys/$key',path: '/journeys/$key',getParentRoute: () => rootRouteImport
          })
const ProveMeWrongReturnRoute = ProveMeWrongReturnRouteImport.update({
            id: '/return',path: '/return',getParentRoute: () => ProveMeWrongRoute
          })
const QuizSlugRoute = QuizSlugRouteImport.update({
            id: '/quiz/$slug',path: '/quiz/$slug',getParentRoute: () => rootRouteImport
          })
const ShopIndexRoute = ShopIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ShopRoute
          })
const ShopUltimateTriviaPackRoute = ShopUltimateTriviaPackRouteImport.update({
            id: '/ultimate-trivia-pack',path: '/ultimate-trivia-pack',getParentRoute: () => ShopRoute
          })
const UUsernameRoute = UUsernameRouteImport.update({
            id: '/u/$username',path: '/u/$username',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedFounderRoute: AuthenticatedFounderRoute,AuthenticatedHealthRoute: AuthenticatedHealthRoute,AuthenticatedHistoryRoute: AuthenticatedHistoryRoute,AuthenticatedMeRoute: AuthenticatedMeRoute,AuthenticatedSavedRoute: AuthenticatedSavedRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const CollectionsRouteChildren = {
  CollectionsSlugRoute: CollectionsSlugRoute,CollectionsIndexRoute: CollectionsIndexRoute
}

const CollectionsRouteWithChildren = CollectionsRoute._addFileChildren(CollectionsRouteChildren)




const ProveMeWrongRouteChildren = {
  ProveMeWrongReturnRoute: ProveMeWrongReturnRoute
}

const ProveMeWrongRouteWithChildren = ProveMeWrongRoute._addFileChildren(ProveMeWrongRouteChildren)




const ShopRouteChildren = {
  ShopUltimateTriviaPackRoute: ShopUltimateTriviaPackRoute,ShopIndexRoute: ShopIndexRoute
}

const ShopRouteWithChildren = ShopRoute._addFileChildren(ShopRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AdminLoginRoute: AdminLoginRoute,AuthRoute: AuthRoute,CategoriesRoute: CategoriesRoute,CollectionsRoute: CollectionsRouteWithChildren,ContactRoute: ContactRoute,DeckRoute: DeckRoute,DescentRoute: DescentRoute,DiscoveriesRoute: DiscoveriesRoute,ExploreRoute: ExploreRoute,FeedRoute: FeedRoute,NewsletterRoute: NewsletterRoute,PlayRoute: PlayRoute,PressRoute: PressRoute,PrivacyRoute: PrivacyRoute,ProveMeWrongRoute: ProveMeWrongRouteWithChildren,QuizzesRoute: QuizzesRoute,RefundsRoute: RefundsRoute,ReleaseNotesRoute: ReleaseNotesRoute,ResetPasswordRoute: ResetPasswordRoute,ShopRoute: ShopRouteWithChildren,SurvivalRoute: SurvivalRoute,TermsRoute: TermsRoute,TrendingRoute: TrendingRoute,UnsubscribeRoute: UnsubscribeRoute,WelcomeRoute: WelcomeRoute,CategorySlugRoute: CategorySlugRoute,ChallengeCodeRoute: ChallengeCodeRoute,DiscoverySlugRoute: DiscoverySlugRoute,JourneysKeyRoute: JourneysKeyRoute,QuizSlugRoute: QuizSlugRoute,UUsernameRoute: UUsernameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)